import React, { Component, Fragment } from "react";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class Alerts extends Component {
  static propTypes = {
    error: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { error, alert, message } = this.props;
    const showInformation = () => {
      if (message !== prevProps.message) {
        if (message.fetchCodeSuccess) alert.success(message.fetchCodeSuccess);
        if (message.fetchEmailCodeSuccess)
          alert.success(message.fetchEmailCodeSuccess);
        if (message.fetchCodeFail) alert.error(message.fetchCodeFail);
        if (message.fetchEmailCodeFail) alert.error(message.fetchEmailCodeFail);
        if (message.resetPasswordSuccess) {
          alert.success("密码修改成功");
        }
        if (message.resetMobileSuccess) {
          alert.success("手机号修改成功");
        }
      }
      if (error.msg.username == "A user with that username already exists.")
        alert.error("用户名已存在");
      if (error != prevProps.error) {
        if (error.msg[0] == "原密码不正确") {
          alert.error("原密码不正确");
        }
        if (error.msg.newPassword == "密码格式有误") {
          alert.error("新密码格式有误");
        }
        if (error.msg.non_field_errors) {
          alert.error(error.msg.non_field_errors[0]);
        }
      }
      if (error.msg.mobile == "user with this mobile already exists.")
        alert.error("该手机号已注册");
      if (error.msg.mobile == "该手机号已注册") alert.error("该手机号已注册");
      else if (error.msg.mobile == "手机号未注册") alert.error("手机号未注册");
      if (error.msg.email == "user with this email already exists.")
        alert.error("该邮箱已注册");
      if (
        error.msg == "No active account found with the given credentials"
      ) {
        alert.error("账号或密码错误");
      }
      if (
        error.msg == "unBind application"
      ) {
        alert.error("该账号未绑定应用，请联系管理员");
      }
    };
    showInformation();
  }
  render() {
    return <Fragment />;
  }
}

const mapStateToProps = (state) => ({
  error: state.errors,
  message: state.messages,
});

export default connect(mapStateToProps)(withAlert()(Alerts));
